import React, { useState, useEffect, useMemo } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Select from 'react-select'
import Topbar from '../../layouts/Topbar'
import Sidebar from '../../layouts/Sidebar'
import { API_BASE_URL } from '../../../config/api'

const quarterOptions = [
  { value: 'Q1', label: 'Quarter 1' },
  { value: 'Q2', label: 'Quarter 2' },
  { value: 'Q3', label: 'Quarter 3' },
  { value: 'Q4', label: 'Quarter 4' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Bi-Weekly', label: 'Bi-Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Semi-Annually', label: 'Semi-Annually' },
  { value: 'Annually', label: 'Annually' },
]

const monthOptions = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

const performanceStandardOptions = [
  { value: 'Q1', label: 'Quarter 1' },
  { value: 'Q2', label: 'Quarter 2' },
  { value: 'Q3', label: 'Quarter 3' },
  { value: 'Q4', label: 'Quarter 4' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Bi-Weekly', label: 'Bi-Weekly' },
  { value: 'Semi-Annually', label: 'Semi-Annually' },
  { value: 'Annually', label: 'Annually' },
  { value: 'Monthly', label: 'MONTHLY' },
  { value: 'Quarterly', label: 'QUARTELY' },
  { value: 'Always', label: 'ALWAYS' },
  { value: 'As and when necessary', label: 'AS AND WHEN NECESSARY' },
  { value: 'As and when required', label: 'AS AND WHEN REQUIRED' },
  { value: 'Daily', label: 'DAILY' },
  { value: 'Annually in line with policies and procedures', label: 'ANNUALLY IN LINE WITH POLICIES AND PROCEDURES' },
  { value: 'Quarterly accurate records daily', label: 'QUARTELY ACCURATE RECORDS DAILY' }
]

const initialFormState = {
  key_result_area: null,
  activity: '',
  metric: '',
  stakeholder: '',
  performance_standard: null,
  quarter: null,
  year: new Date().getFullYear(),
  week: '',
  month: null
}

const selectStyles = {
  control: (base) => ({ ...base, minHeight: '38px' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 })
}

const COSCreateGoal = () => {
  const navigate = useNavigate()
  const baseUrl = API_BASE_URL
  const [activeTab, setActiveTab] = useState('create')

  // --- Create KPI State ---
  const [loading, setLoading] = useState(false)
  const [fetchingKRAs, setFetchingKRAs] = useState(true)
  const [kras, setKras] = useState([])
  const [form, setForm] = useState(initialFormState)

  const currentYear = new Date().getFullYear()
  const years = [currentYear, currentYear + 1]

  // --- Import KPIs State ---
  const [file, setFile] = useState(null)
  const [importYear, setImportYear] = useState(new Date().getFullYear())
  const [uploading, setUploading] = useState(false)

  const importYears = useMemo(() => {
    const currYear = new Date().getFullYear()
    return [currYear, currYear + 1]
  }, [])

  const templateHeaders = [
    'year',
    'key_result_area',
    'period',
    'month',
    'week',
    'activity',
    'performance_standard',
    'metric',
    'stakeholder'
  ]

  const downloadTemplate = () => {
    const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
    const href = `${publicBase}/templates/kpi_bulk_template.csv`

    fetch(href, { cache: 'no-store' })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Template not found (${res.status})`)
        }
        const blob = await res.blob()
        const url = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = url
        a.download = `kpi_bulk_template_${importYear}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        console.log(err)
        const sampleRow = ['1', 'Increase customer retention', '10', 'Customer Success', 'Q1', String(importYear)]
        const csv = [
          templateHeaders.join(','),
          sampleRow.map((v) => `"${String(v).replaceAll('"', '""')}"`).join(',')
        ].join('\n')

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `kpi_bulk_template_${importYear}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
        toast.info('Template file not found on server; downloaded a sample CSV template instead.')
      })
  }

  const handleImportSubmit = async (e) => {
    e.preventDefault()

    if (!file) {
      toast.error('Please select an Excel/CSV file to upload.')
      return
    }

    setUploading(true)
    try {
      const token = Cookies.get('token')
      const formData = new FormData()
      formData.append('file', file)
      formData.append('year', String(importYear))

      await axios.post(`${baseUrl}/api/goals/bulk-create/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      toast.success('File uploaded successfully.')
      setFile(null)
    } catch (err) {
      console.log(err)
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Failed to upload file.'
      toast.error(message)
    } finally {
      setUploading(false)
    }
  }

  useEffect(() => {
    if (activeTab !== 'create') return

    const fetchKRAs = async () => {
      setFetchingKRAs(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/key-result-areas/?year=${encodeURIComponent(form.year)}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        setKras(Array.isArray(response.data) ? response.data : [])
      } catch (err) {
        toast.error(err.response?.data?.detail || err.response?.data?.message || 'Failed to fetch Key Result Areas.')
      } finally {
        setFetchingKRAs(false)
      }
    }
    fetchKRAs()
  }, [baseUrl, form.year, activeTab])

  const kraOptions = kras.map(kra => ({
    value: kra.id,
    label: kra.name
  }))

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value)
    setForm({ ...form, year, key_result_area: null })
  }

  const handleSelectChange = (selected, { name }) => {
    setForm({ ...form, [name]: selected })
  }

  const isFormInvalid =
    !form.key_result_area ||
    !form.activity ||
    !form.metric ||
    !form.stakeholder ||
    !form.quarter ||
    !form.performance_standard ||
    !form.year ||
    (form.quarter?.value === 'Weekly' && !form.week) ||
    (form.quarter?.value === 'Monthly' && !form.month)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isFormInvalid) return
    setLoading(true)

    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/goals/`, {
        key_result_area_id: form.key_result_area?.value,
        activity: form.activity.trim(),
        metric: parseInt(form.metric),
        stakeholder: form.stakeholder.trim(),
        performance_standard: form.performance_standard?.value,
        quarter: form.quarter?.value,
        week: form.quarter?.value === 'Weekly' ? parseInt(form.week) : null,
        month: form.quarter?.value === 'Monthly' ? parseInt(form.month?.value) : null,
        year: form.year
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Goal created successfully!')
      setForm(initialFormState)
      setTimeout(() => navigate('/cos/goals'), 1200)
    } catch (err) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        (typeof err.response?.data === 'string' ? err.response.data : null) ||
        'Failed to create goal.'
      toast.error(message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3500} hideProgressBar={false} />
      <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
        <Topbar />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content pb-0">
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
              <div>
                <h4 className="fw-bold mb-1">Key Performance Indicators</h4>
                <p className="text-muted mb-0 fs-13">Manage and add KPIs to your performance management system</p>
              </div>
              {activeTab === 'import' && (
                <button
                  type="button"
                  onClick={downloadTemplate}
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                >
                  <i className="ti ti-download" /> Download Template CSV
                </button>
              )}
            </div>

            <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'create' ? 'active' : ''}`}
                  onClick={() => setActiveTab('create')}
                  type="button"
                  role="tab"
                >
                  <i className="ti ti-plus me-1"></i> Create Single KPI
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'import' ? 'active' : ''}`}
                  onClick={() => setActiveTab('import')}
                  type="button"
                  role="tab"
                >
                  <i className="ti ti-file-import me-1"></i> Import KPIs
                </button>
              </li>
            </ul>

            <div className="tab-content">
              {activeTab === 'create' && (
            <div className="card shadow-sm mb-4">
              <div className="card-header bg-light border-bottom py-3">
                <h6 className="card-title mb-0 fw-bold text-dark">KPI Details</h6>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Year <span className="text-danger">*</span>
                    </label>
                    <select
                      name="year"
                      value={form.year}
                      onChange={handleYearChange}
                      required
                      className="form-select"
                      disabled={loading}
                    >
                      {years.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Key Result Area <span className="text-danger">*</span>
                      </label>
                      <Select
                        name="key_result_area"
                        value={form.key_result_area}
                        onChange={handleSelectChange}
                        options={kraOptions}
                        placeholder={fetchingKRAs ? 'Loading KRAs...' : 'Select Key Result Area'}
                        classNamePrefix="react-select"
                        isDisabled={loading || fetchingKRAs}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Period <span className="text-danger">*</span>
                      </label>
                      <Select
                        name="quarter"
                        value={form.quarter}
                        onChange={handleSelectChange}
                        options={quarterOptions}
                        placeholder="Select Period"
                        classNamePrefix="react-select"
                        isDisabled={loading}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>

                  {form.quarter?.value === 'Weekly' && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">
                        Week Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="week"
                        value={form.week}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Enter week number (1-52)"
                        min="1"
                        max="52"
                        disabled={loading}
                      />
                    </div>
                  )}

                  {form.quarter?.value === 'Monthly' && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">
                        Month <span className="text-danger">*</span>
                      </label>
                      <Select
                        name="month"
                        value={form.month}
                        onChange={handleSelectChange}
                        options={monthOptions}
                        placeholder="Select Month"
                        classNamePrefix="react-select"
                        isDisabled={loading}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Activity <span className="text-danger">*</span>
                    </label>
                    <textarea
                      name="activity"
                      value={form.activity}
                      onChange={handleChange}
                      required
                      className="form-control"
                      placeholder="Describe the activity or task..."
                      rows="4"
                      disabled={loading}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Performance Standard <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="performance_standard"
                      value={form.performance_standard}
                      onChange={handleSelectChange}
                      options={performanceStandardOptions}
                      placeholder="Select Performance Standard"
                      classNamePrefix="react-select"
                      isDisabled={loading}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                    />
                  </div>

                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Metric <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="metric"
                        value={form.metric}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Enter metric value"
                        min="0"
                        disabled={loading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Stakeholder <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="stakeholder"
                        value={form.stakeholder}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Enter stakeholder name"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <Link
                      to="/cos/goals"
                      className="btn btn-light"
                      onClick={(e) => loading && e.preventDefault()}
                    >
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      className="btn btn-primary d-inline-flex align-items-center gap-2"
                      disabled={loading || isFormInvalid}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          <span>Creating KPI...</span>
                        </>
                      ) : (
                        <>
                          <i className="ti ti-device-floppy fs-18" />
                          <span>Create KPI</span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
              )}

              {activeTab === 'import' && (
                <div className="card shadow-sm max-w-700">
                  <div className="card-header bg-light border-bottom py-3">
                    <h6 className="card-title mb-0 fw-bold text-dark">
                      Bulk KPI Upload Form
                    </h6>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleImportSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label fw-medium">
                            Select Target Year <span className="text-danger">*</span>
                          </label>
                          <select
                            value={importYear}
                            onChange={(e) => setImportYear(parseInt(e.target.value))}
                            className="form-select"
                            disabled={uploading}
                          >
                            {importYears.map((y) => (
                              <option key={y} value={y}>
                                {y}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label className="form-label fw-medium">
                            Excel / CSV File <span className="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                            disabled={uploading}
                            onChange={(e) => setFile(e.target.files?.[0] ?? null)}
                            className="form-control"
                            required
                          />
                          <div className="form-text fs-12 text-muted mt-1">
                            Supported formats: .xlsx, .xls, .csv
                          </div>
                          {file && (
                            <div className="form-text fs-12 mt-1 d-flex align-items-center gap-1 text-success">
                              <i className="ti ti-file-check" />
                              Selected: <strong>{file.name}</strong> ({(file.size / 1024).toFixed(2)} KB)
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-end gap-2 mt-4 pt-3 border-top">
                        <button
                          type="button"
                          onClick={downloadTemplate}
                          disabled={uploading}
                          className="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
                        >
                          <i className="ti ti-download" />
                          Get Template
                        </button>
                        <button
                          type="submit"
                          disabled={uploading}
                          className="btn btn-primary d-flex align-items-center gap-2 px-4"
                        >
                          {uploading ? (
                            <>
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                              Uploading...
                            </>
                          ) : (
                            <>
                              <i className="ti ti-upload" /> Upload &amp; Submit
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
            <p className="text-dark mb-0">
              2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default COSCreateGoal
